import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PreferenceForm } from '../../../models/preference-form/preference-form.model';
import { PreferenceFormSerializer } from '../../../models/preference-form/preference-form-serializer.class';
import { CustomErrorHandlerService } from '../custom-error-handler.service';

@Injectable()
export class PreferenceFormService extends BaseApiService<PreferenceForm> {
  constructor(httpClient: HttpClient) {
    super(
        httpClient, 
        null, 
        "preferenceforms", 
        new PreferenceFormSerializer(), 
        new CustomErrorHandlerService());
  }
}
